import { DATA_NODES_PAGE_SIZE } from './hooks/useDataNodesByType';
import { createNextOffsetGetter } from './offsetPaging';

/**
 * Cap on connected nodes the **graph canvas** fetches per relation, in a single request. This is a
 * product choice, not a backend limit: `GetConnectedNodeRequest` accepts an unbounded `Offset`, so the
 * endpoint pages fine (see `CONNECTED_NODES_GRID_PAGE_SIZE`). The graph doesn't page because a
 * relation with more connected instances than this is expected to be narrowed server-side in the
 * future — rendering that many children on the canvas at once wouldn't be usable anyway.
 */
export const CONNECTED_NODES_PAGE_SIZE = 100;

/**
 * Page size a **list** surface uses over the same endpoint. Aliased to `DATA_NODES_PAGE_SIZE` rather
 * than repeated, so both grid modes are guaranteed to scroll identically instead of relying on two
 * literals staying equal. Both must stay <= 100 — `GetConnectedNodeRequest.Limit` is `[Range(1, 100)]`,
 * so a larger value is a 400, not a silent truncation.
 */
export const CONNECTED_NODES_GRID_PAGE_SIZE = DATA_NODES_PAGE_SIZE;

/**
 * Next-offset rule for offset-paging the connected-nodes listing. Shares its rule with
 * `getNextNodesOffset` for the type-wide listing (see `createNextOffsetGetter`); only the page size
 * differs.
 */
export const getNextConnectedNodesOffset = createNextOffsetGetter(CONNECTED_NODES_GRID_PAGE_SIZE);
